import s from './style.module.scss'
const CLoseButton = () => {
    return <div className={s['close-btn']} role="button" aria-label="关闭" tabindex="0">

    </div>
}
export default CLoseButton